module.exports = [{"value":"en","iso":"gb","url":"en/resume","name":"English","englishName":"English"},{"value":"fr","iso":"fr","url":"fr/cv","name":"Français","englishName":"French"},{"value":"ja","iso":"ja","url":"ja/rirekisho","name":"日本語","englishName":"Japanese"}]


//////////////////
// WEBPACK FOOTER
// ./src/i18n/languages.json
// module id = 757
// module chunks = 0